/* eslint-disable react-hooks/exhaustive-deps, react/jsx-props-no-spreading */
import { useEffect, createContext, useRef, useMemo, useState, useCallback } from "react";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import { Chakra } from "@airhelp/react-ui-components";
import useDeviceSize from "hooks/useDeviceSize";

const { Box, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, useDisclosure } = Chakra;

export const MobileMenuContext = createContext({});

export const MobileMenuContextProvider = ({ children }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [mobileMenuContent, setMobileMenuContent] = useState(null);
  const btnRef = useRef();
  const { isDesktop } = useDeviceSize();

  const closeMobileMenuOnLargeScreen = () => {
    if (isDesktop) onClose();
  };

  useEffect(() => {
    window.addEventListener("resize", throttle(closeMobileMenuOnLargeScreen, 100));

    return () => window.removeEventListener("resize", closeMobileMenuOnLargeScreen);
  }, []);

  const openMobileMenu = useCallback(
    (content) => {
      if (content) {
        onOpen();
        setMobileMenuContent(content);
      }
    },
    [onOpen]
  );

  const value = useMemo(
    () => ({
      openMobileMenu,
    }),
    [openMobileMenu]
  );

  return (
    <MobileMenuContext.Provider value={value}>
      {children}
      <Drawer isOpen={isOpen} onClose={onClose} finalFocusRef={btnRef}>
        <Box display={{ lg: "none" }}>
          <DrawerOverlay bg="rgba(69, 84, 115, 0.7)" />
          <DrawerContent>
            <DrawerCloseButton
              size="lg"
              color="primary.900"
              _hover={{ color: "primary.500", bg: "white" }}
              _active={{ color: "primary.700", bg: "white" }}
              rounded="full"
              mt={2}
              mr={1}
            />
            {mobileMenuContent}
          </DrawerContent>
        </Box>
      </Drawer>
    </MobileMenuContext.Provider>
  );
};

MobileMenuContextProvider.propTypes = {
  children: PropTypes.node,
};

MobileMenuContextProvider.defaultProps = {
  children: null,
};
